import { c as _c } from "react-compiler-runtime";
import { cn } from "@/core/utils";
type AssessmentAmbientFrameProps = {
  readonly children: React.ReactNode;
  readonly topSlot?: React.ReactNode;
  readonly className?: string;
  readonly contentClassName?: string;
};
export default function AssessmentAmbientFrame(t0) {
  const $ = _c(16);
  const {
    children,
    topSlot,
    className,
    contentClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("assessment-ambient-shell bg-background relative isolate overflow-hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="assessment-ambient-region pointer-events-none absolute inset-x-0 top-20 bottom-6 sm:top-24 sm:bottom-8"><div className="assessment-ambient-spotlight absolute top-[42%] left-1/2 h-[40rem] w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full sm:h-[54rem] sm:w-[54rem]" data-testid="assessment-ambient-spotlight" /><div className="assessment-ambient-blob assessment-ambient-blob-one absolute top-12 -left-24 h-80 w-80 rounded-full sm:h-[28rem] sm:w-[28rem]" data-testid="assessment-ambient-blob-1" /><div className="assessment-ambient-blob assessment-ambient-blob-two absolute top-[29%] right-[-6rem] h-72 w-80 rounded-full sm:h-[24rem] sm:w-[28rem]" data-testid="assessment-ambient-blob-2" /><div className="assessment-ambient-blob assessment-ambient-blob-three absolute bottom-[-8rem] left-[28%] h-80 w-80 rounded-full sm:h-[24rem] sm:w-[24rem]" data-testid="assessment-ambient-blob-3" /><div className="assessment-ambient-grain absolute inset-0" data-testid="assessment-ambient-grain" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== topSlot) {
    t3 = topSlot ? <div className="mx-auto w-full max-w-xl">{topSlot}</div> : null;
    $[3] = topSlot;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== contentClassName) {
    t4 = cn("mx-auto flex w-full max-w-xl flex-1 flex-col pt-4 sm:pt-6", contentClassName);
    $[5] = contentClassName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[7] = children;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-1 flex-col pt-3 pb-8 sm:pt-4 sm:pb-10">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t6) {
    t7 = <div className={t1} data-testid="assessment-ambient-shell">{t2}{t6}</div>;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}